import { z } from "zod";

export const dateRangeArgsSchema = z.object({
  dates: z.object({ date_from: z.string(), date_to: z.string().nullish() }),
});

export const availabilityArgsSchema = z.object({ target_date: z.string() });

export const noArgsSchema = z.object({});
